import React, { ReactNode } from 'react'
import Link from '@corratech/pylot-ui/src/Link'
import cn from 'classnames'

interface BreadcrumbItemProps {
    url?: string
    title: string
    active?: boolean
    className?: string
}

export const BreadcrumbItem = ({
    url,
    title,
    active = false,
    className
}: BreadcrumbItemProps): JSX.Element => {
    const breadcrumbs: string = title
        .split(' ')
        .find((item) => item.toLowerCase() == 'ooka')!
    const breadcrumbsTitle: string = title.replace(breadcrumbs, 'OOKA')!

    return (
        <BreadcrumbLink
            href={url}
            linkClass={cn(className, { active: active })}
        >
            {breadcrumbsTitle}
        </BreadcrumbLink>
    )
}

type BreadcrumbLinkProps = {
    href?: string
    children: ReactNode
    linkClass?: string
}

const BreadcrumbLink = ({ href, children, linkClass }: BreadcrumbLinkProps) => {
    return href ? <Link href={href}>{children}</Link> : <span>{children}</span>
}
